/** Имя микрофронтенда рекламных баннеров */
export const AD_BANNER_MF_NAME = 'ad-banner-frontend';

/** Глобальный флаг конфига, включающий интеграцию с микрофронтендом баннеров */
export const AD_BANNER_MF_ENABLED_KEY = 'MarTech.AdBannerMicrofrontend.Enabled';

/** Ключ настройки, под которым манифест микрофронтенда едет в браузер */
export const AD_BANNER_MF_MANIFEST_SETTING_KEY = 'adBannerMicrofrontendManifest';
